var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{attrs:{"gutter":20}},[_c('a-col',{attrs:{"span":12}},[(_vm.empi)?_c('patient-list',{attrs:{"listUrl":"/management/empiPix/patientList","baseParams":{empi:_vm.empi},"search":false},on:{"onselect":_vm.handleSelect}}):_vm._e()],1),_c('a-col',{attrs:{"span":12}},[_c('empi-pix-list',{ref:"pix-list"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }